import React, { useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Import images
import IMG_6707 from "assets/images/Teilnehmer/IMG_6707.jpg";
import IMG_6708 from "assets/images/Teilnehmer/IMG_6708.jpg";
import IMG_6709 from "assets/images/Teilnehmer/IMG_6709.jpg";
import IMG_6710 from "assets/images/Teilnehmer/IMG_6710.jpg";
import IMG_6711 from "assets/images/Teilnehmer/IMG_6711.jpg";
import IMG_6712 from "assets/images/Teilnehmer/IMG_6712.jpg";
import IMG_6713 from "assets/images/Teilnehmer/IMG_6713.jpg";
import IMG_6714 from "assets/images/Teilnehmer/IMG_6714.jpg";
import IMG_6715 from "assets/images/Teilnehmer/IMG_6715.jpg";
import IMG_6716 from "assets/images/Teilnehmer/IMG_6716.jpg";

const TeilnehmerSlider = () => {
  const images = [
    { src: IMG_6707, alt: "Teilnehmer Testimonial 1" },
    { src: IMG_6708, alt: "Teilnehmer Testimonial 2" },
    { src: IMG_6709, alt: "Teilnehmer Testimonial 3" },
    { src: IMG_6710, alt: "Teilnehmer Testimonial 4" },
    { src: IMG_6711, alt: "Teilnehmer Testimonial 5" },
    { src: IMG_6712, alt: "Teilnehmer Testimonial 6" },
    { src: IMG_6713, alt: "Teilnehmer Testimonial 7" },
    { src: IMG_6714, alt: "Teilnehmer Testimonial 8" },
    { src: IMG_6715, alt: "Teilnehmer Testimonial 9" },
    { src: IMG_6716, alt: "Teilnehmer Testimonial 10" },
  ];
  const PrevArrow = useCallback((props) => {
    const { onClick } = props;
    return (
      <FiArrowLeftCircle
        onClick={onClick}
        color="rgb(160, 195, 221)"
        width={"50%"}
      />
    );
  }, []);

  const NextArrow = useCallback((props) => {
    const { onClick } = props;
    return <FiArrowRightCircle onClick={onClick} color="#2ECF96" />;
  }, []);
  return (
    <SliderContainer>
      <Swiper
        observeParents={true}
        observer={true}
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        }}
        loop={true}
        breakpoints={{
          // When window width is >= 640px
          640: {
            slidesPerView: 1,
          },
          // When window width is >= 768px
          768: {
            slidesPerView: 2,
          },
          // When window width is >= 1024px
          1024: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <SlideContent>
              <SlideImage src={image.src} alt={image.alt} />
            </SlideContent>
          </SwiperSlide>
        ))}
      </Swiper>
      <CustomNavigation>
        <div className="swiper-button-prev custom">
          <PrevArrow />
        </div>
        <div className="swiper-button-next custom">
          <NextArrow />
        </div>
      </CustomNavigation>
    </SliderContainer>
  );
};

// Styled Components
const SliderContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 0 40px 0;
  @media screen and (max-width: 768px) {
    padding: 0 0 20px 0;
  }

  /* Custom styles for Swiper navigation buttons */
  .swiper-button-next,
  .swiper-button-prev {
    color: #000;
    background-color: rgba(255, 255, 255, 0.7);
    width: 32px;
    height: 32px;
    border-radius: 50%;

    &::after {
      font-size: 16px;
    }

    @media (max-width: 768px) {
      width: 28px;
      height: 28px;

      &::after {
        font-size: 14px;
      }
    }
  }

  /* Custom styles for pagination dots */
  .swiper-pagination-bullet {
    background: #888;
    opacity: 0.6;

    &-active {
      background: #000;
      opacity: 1;
    }
  }
`;

const SlideContent = styled.div`
  position: relative;
  height: 280px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    height: 380px;
  }

  @media (min-width: 1024px) {
    height: 450px;
  }
`;

const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const CustomNavigation = styled.div`
  // Removed relative positioning and height: 0
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px; // Space between arrows
  margin-top: 15px; // Space above arrows

  .swiper-button-prev.custom,
  .swiper-button-next.custom {
    position: static; // Changed from absolute
    width: 25px;
    height: 25px;
    background: none;
    margin: 0; // Reset margins

    &::after {
      display: none;
    }
  }

  // Removed left positioning rules
`;
export default TeilnehmerSlider;
